import { userService } from './services';

export default {
  // post
  login: (data) => userService().post('/auth/login', data),
  introspection: (data) => userService().post('/auth/introspection', data),
};
